import { tField } from './bilingualHelper';

export const generateBatchFinancialCSV = (batchName, students) => {
  if (!students || students.length === 0) return alert('No students to download.');
  const headers = ['Student ID', 'Student Name', 'Guardian', 'Contact', 'Balance (HKD)', 'Total Paid (HKD)', 'Status', 'Paid Till Month', 'Complimentary Items'];
  const csvRows = [headers.join(',')];
  
  students.forEach(s => {
    const validItems = (s.purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
    const compItems = validItems.length > 0 ? validItems.map(pm => tField(pm.merchandise.name)).join(', ') : 'N/A';
    const row = [
      `"${s.rollNumber || 'STU-ID'}"`,
      `"${tField(s.name)}"`,
      `"${s.guardianName || ''}"`,
      `"${s.guardianPhone || ''}"`,
      `"${s.balance || 0}"`,
      `"${s.amountPaid || 0}"`,
      `"${s.status ? s.status.toUpperCase() : 'UNKNOWN'}"`,
      `"${s.paidTillMonth && s.paidTillMonth !== 'None' ? s.paidTillMonth : 'N/A'}"`,
      `"${compItems}"`
    ];
    csvRows.push(row.join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Batch_Financial_Summary_${batchName.replace(/\s+/g, '_')}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const generateBatchFinancialPDF = (batchName, students) => {
  if (!students || students.length === 0) return alert('No students to print.');
  
  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>Batch Financial Summary - ${batchName}</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 40px; color: #333; }
          h1 { color: #7b1d3a; margin-bottom: 5px; }
          p { color: #666; margin-top: 0; margin-bottom: 30px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
          th { background-color: #f8f9fa; color: #444; }
          .badge { padding: 4px 8px; border-radius: 4px; font-weight: bold; font-size: 12px; }
          .PAID { background: #e8f5e9; color: #2e7d32; }
          .OVERDUE { background: #ffebee; color: #c62828; }
          .PARTIALLY_PAID { background: #fff8e1; color: #f57f17; }
        </style>
      </head>
      <body>
        <h1>Batch Financial Summary: ${batchName}</h1>
        <p>Generated on: ${new Date().toLocaleDateString()}</p>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Student Name</th>
              <th>Guardian</th>
              <th>Balance (HKD)</th>
              <th>Total Paid (HKD)</th>
              <th>Status</th>
              <th>Complimentary Items</th>
            </tr>
          </thead>
          <tbody>
            ${students.map(s => {
              const statusClass = (s.status || '').toUpperCase().replace(' ', '_');
              const validItems = (s.purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
              const compItems = validItems.length > 0 ? validItems.map(pm => tField(pm.merchandise.name)).join(', ') : 'N/A';
              return `
              <tr>
                <td>${s.rollNumber || 'STU-ID'}</td>
                <td><strong>${tField(s.name)}</strong></td>
                <td>${s.guardianName || ''}<br><small>${s.guardianPhone || ''}</small></td>
                <td style="color: ${s.balance > 0 ? '#c62828' : '#2e7d32'}; font-weight: bold;">$${s.balance || 0}</td>
                <td>$${s.amountPaid || 0}</td>
                <td><span class="badge ${statusClass}">${s.status ? s.status.toUpperCase() : 'UNKNOWN'}</span></td>
                <td>${compItems}</td>
              </tr>
            `}).join('')}
          </tbody>
        </table>
        <script>
          window.onload = () => { window.print(); };
        </script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};

export const generateStudentLedgerCSV = (studentName, batchName, feeHistory, purchasedMerchandise) => {
  if (!feeHistory || feeHistory.length === 0) return alert('No fee history to download.');
  
  const compItemsList = (purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
  const compItems = compItemsList.length > 0 ? compItemsList.map(pm => tField(pm.merchandise.name)).join(' | ') : 'N/A';

  const headers = ['Month', 'Year', 'Expected Amount (HKD)', 'Paid Amount (HKD)', 'Status', 'Complimentary Items'];
  const csvRows = [headers.join(',')];
  
  feeHistory.forEach((r, index) => {
    const row = [
      `"${r.month}"`,
      `"${r.year}"`,
      `"${r.expectedAmount || 0}"`,
      `"${r.paidAmount || 0}"`,
      `"${r.status ? r.status.toUpperCase() : 'UNKNOWN'}"`,
      `"${index === 0 ? compItems : ''}"` // Only show comp items on first row to avoid clutter
    ];
    csvRows.push(row.join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Ledger_${studentName.replace(/\s+/g, '_')}_${batchName.replace(/\s+/g, '_')}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const generateStudentLedgerPDF = (studentName, batchName, feeHistory, purchasedMerchandise) => {
  if (!feeHistory || feeHistory.length === 0) return alert('No fee history to print.');
  
  const compItemsList = (purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
  const compItems = compItemsList.length > 0 ? compItemsList.map(pm => tField(pm.merchandise.name)).join(', ') : 'N/A';

  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>Fee Ledger - ${studentName}</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 40px; color: #333; }
          h1 { color: #7b1d3a; margin-bottom: 5px; }
          p { color: #666; margin-top: 0; margin-bottom: 30px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
          th { background-color: #f8f9fa; color: #444; }
          .badge { padding: 4px 8px; border-radius: 4px; font-weight: bold; font-size: 12px; }
          .PAID { background: #e8f5e9; color: #2e7d32; }
          .OVERDUE { background: #ffebee; color: #c62828; }
          .PARTIALLY_PAID { background: #fff8e1; color: #f57f17; }
          .PENDING { background: #fffaf0; color: #e65100; }
        </style>
      </head>
      <body>
        <h1>Fee Ledger: ${studentName}</h1>
        <p>Batch: ${batchName}<br>Generated on: ${new Date().toLocaleDateString()}<br>Complimentary Items: <strong>${compItems}</strong></p>
        <table>
          <thead>
            <tr>
              <th>Month/Year</th>
              <th>Expected Amount (HKD)</th>
              <th>Paid Amount (HKD)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            ${feeHistory.filter(item => item.status !== 'not_applicable').map(r => {
              const statusClass = (r.status || '').toUpperCase().replace(' ', '_');
              return `
              <tr>
                <td><strong>${r.month} ${r.year}</strong></td>
                <td>$${r.expectedAmount || 0}</td>
                <td>$${r.paidAmount || 0}</td>
                <td><span class="badge ${statusClass}">${r.status ? r.status.toUpperCase() : 'UNKNOWN'}</span></td>
              </tr>
            `}).join('')}
          </tbody>
        </table>
        <script>
          window.onload = () => { window.print(); };
        </script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};

export const generateBatchMonthlyCSV = (batchName, monthStr, reportData) => {
  if (!reportData || reportData.length === 0) return alert('No data for this month.');
  const headers = ['Student ID', 'Student Name', 'Guardian', 'Expected (HKD)', 'Paid (HKD)', 'Status', 'Complimentary Items'];
  const csvRows = [headers.join(',')];
  
  reportData.forEach(s => {
    const validItems = (s.purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
    const compItems = validItems.length > 0 ? validItems.map(pm => tField(pm.merchandise.name)).join(', ') : 'N/A';
    const row = [
      `"${s.rollNumber || 'STU-ID'}"`,
      `"${tField(s.name)}"`,
      `"${s.guardianName || ''}"`,
      `"${s.expectedForMonth || 0}"`,
      `"${s.paidForMonth || 0}"`,
      `"${s.monthStatus ? s.monthStatus.toUpperCase() : 'UNKNOWN'}"`,
      `"${compItems}"`
    ];
    csvRows.push(row.join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Batch_Monthly_${monthStr.replace(/\s+/g, '_')}_${batchName.replace(/\s+/g, '_')}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const generateBatchMonthlyPDF = (batchName, monthStr, reportData) => {
  if (!reportData || reportData.length === 0) return alert('No data for this month.');
  
  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>Monthly Report - ${monthStr} - ${batchName}</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 40px; color: #333; }
          h1 { color: #7b1d3a; margin-bottom: 5px; }
          p { color: #666; margin-top: 0; margin-bottom: 30px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
          th { background-color: #f8f9fa; color: #444; }
          .badge { padding: 4px 8px; border-radius: 4px; font-weight: bold; font-size: 12px; }
          .PAID { background: #e8f5e9; color: #2e7d32; }
          .OVERDUE { background: #ffebee; color: #c62828; }
          .PARTIALLY_PAID { background: #fff8e1; color: #f57f17; }
          .PENDING { background: #fffaf0; color: #e65100; }
        </style>
      </head>
      <body>
        <h1>Batch Monthly Report: ${monthStr}</h1>
        <p>Batch: ${batchName}<br>Generated on: ${new Date().toLocaleDateString()}</p>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Student Name</th>
              <th>Expected (HKD)</th>
              <th>Paid (HKD)</th>
              <th>Status</th>
              <th>Complimentary Items</th>
            </tr>
          </thead>
          <tbody>
            ${reportData.map(s => {
              const statusClass = (s.monthStatus || '').toUpperCase().replace(' ', '_');
              const validItems = (s.purchasedMerchandise || []).filter(pm => pm && pm.merchandise && pm.merchandise.name);
              const compItems = validItems.length > 0 ? validItems.map(pm => tField(pm.merchandise.name)).join(', ') : 'N/A';
              return `
              <tr>
                <td>${s.rollNumber || 'STU-ID'}</td>
                <td><strong>${tField(s.name)}</strong><br><small>${s.guardianName || ''}</small></td>
                <td>$${s.expectedForMonth || 0}</td>
                <td>$${s.paidForMonth || 0}</td>
                <td><span class="badge ${statusClass}">${s.monthStatus ? s.monthStatus.toUpperCase() : 'UNKNOWN'}</span></td>
                <td>${compItems}</td>
              </tr>
            `}).join('')}
          </tbody>
        </table>
        <script>
          window.onload = () => { window.print(); };
        </script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};

export const generateUnifiedReportCSV = (reportList, dateRangeStr = 'All-Time') => {
  if (!reportList || reportList.length === 0) return alert('No report data to export.');

  const headers = [
    'Student ID',
    'Student Name',
    'Guardian',
    'Contact',
    'Batches',
    'Total Classes',
    'Attended',
    'Late',
    'Absent',
    'Leave',
    'Make-up',
    'Attendance %',
    'Total Paid (HKD)',
    'Balance (HKD)',
    'Status',
    'Paid-Up-To Month'
  ];

  const csvRows = [headers.join(',')];

  reportList.forEach(r => {
    const att = r.attendance || {};
    const tui = r.tuition || {};
    const batchesStr = (r.batches || []).map(b => tField(b)).join('; ');

    const row = [
      `"${r.rollNumber || 'STU-ID'}"`,
      `"${tField(r.name)}"`,
      `"${tField(r.guardianName)}"`,
      `"${r.guardianPhone || ''}"`,
      `"${batchesStr}"`,
      `"${att.totalClasses || 0}"`,
      `"${att.attendedCount || 0}"`,
      `"${att.lateCount || 0}"`,
      `"${att.absentCount || 0}"`,
      `"${att.leaveCount || 0}"`,
      `"${att.makeupCount || 0}"`,
      `"${att.attendanceRate || 100}%"`,
      `"${tui.totalPaid || 0}"`,
      `"${tui.balance || 0}"`,
      `"${tui.feeStatus || 'Pending'}"`,
      `"${tui.paidUpToMonth || 'None'}"`
    ];
    csvRows.push(row.join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Unified_Master_Report_${dateRangeStr.replace(/[\s–—/]/g, '_')}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const generateUnifiedReportPDF = (reportList, dateRangeStr = 'All-Time') => {
  if (!reportList || reportList.length === 0) return alert('No report data to export.');

  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>Unified Master Statement (${dateRangeStr})</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 30px; color: #333; }
          h1 { color: #7b1d3a; margin-bottom: 4px; font-size: 22px; }
          p { color: #666; margin-top: 0; margin-bottom: 20px; font-size: 13px; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; }
          th, td { border: 1px solid #ddd; padding: 8px 10px; text-align: left; font-size: 12px; }
          th { background-color: #f8f9fa; color: #444; font-size: 11px; text-transform: uppercase; }
          .badge { padding: 3px 6px; border-radius: 4px; font-weight: bold; font-size: 10px; }
          .PAID { background: #e8f5e9; color: #2e7d32; }
          .PENDING { background: #fff8e1; color: #f57f17; }
        </style>
      </head>
      <body>
        <h1>Unified Academic & Tuition Statement</h1>
        <p>Date Range: <strong>${dateRangeStr}</strong> &nbsp;|&nbsp; Generated on: ${new Date().toLocaleDateString()} &nbsp;|&nbsp; Total Students: ${reportList.length}</p>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Student Name</th>
              <th>Guardian</th>
              <th>Classes</th>
              <th>Attended</th>
              <th>Late</th>
              <th>Absent</th>
              <th>Leave</th>
              <th>Make-up</th>
              <th>Att %</th>
              <th>Paid (HKD)</th>
              <th>Balance</th>
              <th>Paid Up To</th>
            </tr>
          </thead>
          <tbody>
            ${reportList.map(r => {
              const att = r.attendance || {};
              const tui = r.tuition || {};
              return `
              <tr>
                <td>${r.rollNumber || 'STU-ID'}</td>
                <td><strong>${tField(r.name)}</strong></td>
                <td>${tField(r.guardianName)}<br><small>${r.guardianPhone || ''}</small></td>
                <td>${att.totalClasses || 0}</td>
                <td><span style="color: #2e7d32; font-weight: bold;">${att.attendedCount || 0}</span></td>
                <td><span style="color: #d97706;">${att.lateCount || 0}</span></td>
                <td><span style="color: #dc2626;">${att.absentCount || 0}</span></td>
                <td><span style="color: #2563eb;">${att.leaveCount || 0}</span></td>
                <td><span style="color: #7c3aed;">${att.makeupCount || 0}</span></td>
                <td><strong>${att.attendanceRate || 100}%</strong></td>
                <td>$${(tui.totalPaid || 0).toLocaleString()}</td>
                <td style="color: ${(tui.balance || 0) > 0 ? '#dc2626' : '#2e7d32'}; font-weight: bold;">$${(tui.balance || 0).toLocaleString()}</td>
                <td>${tui.paidUpToMonth || 'None'}</td>
              </tr>
            `}).join('')}
          </tbody>
        </table>
        <script>
          window.onload = () => { window.print(); };
        </script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};

